import { injectIntl } from "react-intl";
import { useEffect, useState, useRef, useCallback } from "react";
import { OperationType } from "src/helpers/Enums";
import apiService from "src/services/api.service";

const MISSING_CREATIVE_OPTIONS = [
  { value: "", label: "All offers" },
  { value: "SMS", label: "No SMS creative" },
  { value: "Email", label: "No Email creative" },
];

const Header = (props) => {
  const [tags, setTags] = useState([]);
  const [tagDropdownOpen, setTagDropdownOpen] = useState(false);
  const [tagSearch, setTagSearch] = useState("");
  const [missingMenuOpen, setMissingMenuOpen] = useState(false);
  const tagDropdownRef = useRef(null);
  const missingMenuRef = useRef(null);

  useEffect(() => {
    apiService.getAllTags().then((response) => {
      setTags(response.data || []);
    });
  }, []);

  const handleClickOutside = useCallback((event) => {
    if (
      tagDropdownRef.current &&
      !tagDropdownRef.current.contains(event.target)
    ) {
      setTagDropdownOpen(false);
      setTagSearch("");
    }
    if (
      missingMenuRef.current &&
      !missingMenuRef.current.contains(event.target)
    ) {
      setMissingMenuOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const toggleTag = (tagId) => {
    const next = props.selectedTagIds.includes(tagId)
      ? props.selectedTagIds.filter((id) => id !== tagId)
      : [...props.selectedTagIds, tagId];
    props.setSelectedTagIds(next);
  };

  const filteredTags = tags.filter((tag) =>
    (tag.name || "").toLowerCase().includes(tagSearch.toLowerCase())
  );

  const selectedTagNames = tags.filter((t) =>
    props.selectedTagIds.includes(t._id)
  );
  const selectedMissingOption =
    MISSING_CREATIVE_OPTIONS.find(
      (option) => option.value === props.missingCreativeType
    ) || MISSING_CREATIVE_OPTIONS[0];

  return (
    <div className="PageHeader">
      <div className={"PageHeaderTitle"}>Offers</div>
      <div className={"flex gap-3 items-center"}>
        <div className="relative flex items-center">
          <span className="absolute left-3">
            <img
              alt={"Logo"}
              src={"/media/icons/searchIcon.svg"}
              className={"h-[17px] w-[17px]"}
            />
          </span>
          <input
            type="text"
            placeholder="Search"
            value={props.search}
            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg outline-none"
            onChange={(e) => props.setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && props.setIsUpdate) {
                props.setIsUpdate(true);
              }
            }}
          />
        </div>
        <div className="relative" ref={missingMenuRef}>
          <button
            type="button"
            className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded-lg bg-white text-sm"
            style={{ fontFamily: "Inter", minWidth: "160px" }}
            onClick={() => setMissingMenuOpen(!missingMenuOpen)}
          >
            <img
              alt=""
              src={"/media/icons/creative.svg"}
              className={"w-4 h-4"}
            />
            <span
              className={`truncate max-w-[160px] font-medium ${
                props.missingCreativeType ? "text-[#15151F]" : "text-gray-400"
              }`}
            >
              {props.missingCreativeType
                ? selectedMissingOption.label
                : "Missing creative"}
            </span>
            <img
              alt=""
              src={"/media/icons/chevronDown.svg"}
              className={"w-4 h-4 ml-auto"}
            />
          </button>
          {missingMenuOpen && (
            <div className="absolute top-full left-0 mt-1 w-[220px] bg-white border border-gray-200 rounded-lg shadow-lg z-50">
              <ul className="p-1">
                {MISSING_CREATIVE_OPTIONS.map((option) => {
                  const selected = props.missingCreativeType === option.value;
                  return (
                    <li key={option.label}>
                      <button
                        type="button"
                        className={`flex w-full items-center rounded px-2 py-1.5 text-left text-sm ${
                          selected
                            ? "bg-[#F9F5FF] text-[#7E50EA]"
                            : "text-[#15151F] hover:bg-gray-50"
                        }`}
                        style={{ fontFamily: "Inter" }}
                        onClick={() => {
                          props.setMissingCreativeType(option.value);
                          setMissingMenuOpen(false);
                        }}
                      >
                        {option.label}
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
        </div>
        <div className="relative" ref={tagDropdownRef}>
          <button
            className="flex items-center gap-2 px-3 py-2 border border-gray-300 rounded-lg bg-white text-sm"
            style={{ fontFamily: "Inter", minWidth: "120px" }}
            onClick={() => setTagDropdownOpen(!tagDropdownOpen)}
          >
            <img
              alt={"Tag"}
              src={"/media/icons/tag.svg"}
              className={"w-4 h-4"}
            />
            {selectedTagNames.length > 0 ? (
              <span className="text-[#15151F] font-medium truncate max-w-[150px]">
                {selectedTagNames.length === 1
                  ? selectedTagNames[0].name
                  : `${selectedTagNames.length} tags`}
              </span>
            ) : (
              <span className="text-gray-400">Filter by Tag</span>
            )}
            <img
              alt={"Chevron"}
              src={"/media/icons/chevronDown.svg"}
              className={"w-4 h-4 ml-auto"}
            />
          </button>
          {tagDropdownOpen && (
            <div
              className="absolute top-full left-0 mt-1 w-[260px] bg-white border border-gray-200 rounded-lg shadow-lg z-50"
              style={{ maxHeight: "320px" }}
            >
              <div className="p-2">
                <div className="relative flex items-center w-full">
                  <span className="absolute left-3">
                    <img
                      alt={"Search"}
                      src={"/media/icons/searchIcon.svg"}
                      className={"h-[14px] w-[14px]"}
                    />
                  </span>
                  <input
                    type="text"
                    placeholder="Search tags..."
                    value={tagSearch}
                    className="w-full pl-9 pr-3 py-1.5 border border-gray-300 rounded-md outline-none text-sm"
                    onChange={(e) => setTagSearch(e.target.value)}
                    autoFocus
                  />
                </div>
              </div>
              {selectedTagNames.length > 0 && (
                <div className="px-2 pb-1">
                  <button
                    className="text-xs text-[#7F56D9] hover:underline"
                    onClick={() => props.setSelectedTagIds([])}
                  >
                    Clear all
                  </button>
                </div>
              )}
              <ul
                className="overflow-y-auto px-1"
                style={{ maxHeight: "230px" }}
              >
                {filteredTags.map((tag) => (
                  <li
                    key={tag._id}
                    className="flex items-center gap-2 px-2 py-1.5 cursor-pointer hover:bg-gray-50 rounded"
                    onClick={() => toggleTag(tag._id)}
                  >
                    <input
                      type="checkbox"
                      checked={props.selectedTagIds.includes(tag._id)}
                      onChange={() => toggleTag(tag._id)}
                      className="CustomCheckbox"
                    />
                    <span
                      className="text-sm text-[#15151F] truncate"
                      style={{ fontFamily: "Inter" }}
                    >
                      {tag.name}
                    </span>
                  </li>
                ))}
                {filteredTags.length === 0 && (
                  <li className="px-2 py-3 text-sm text-gray-400 text-center">
                    No tags found
                  </li>
                )}
              </ul>
            </div>
          )}
        </div>
        <button
          className={"PrimaryButton"}
          onClick={() => props.handleOpenNewOffer(OperationType.CREATE)}
        >
          <img
            alt={"Logo"}
            src={"/media/icons/plusIcon.svg"}
            className={"w-4 h-4"}
          />
          New Offer
        </button>
      </div>
    </div>
  );
};

export default injectIntl(Header);
